//@ts-check

/**
 * @module Tooltip
 */

/**
 * Sets Tooltip Content 
 * @param {Object} content 
 */
export function setTooltipContent(content) {
  this.tooltip.innerHTML = content;
}

/**
 * Formats Tooltip Default
 * @param {HTMLDivElement} canvas 
 */
export function formatTooltipDefault(canvas) {

  let elem = document.createElement('div');

  this.tooltip = canvas.appendChild(elem);
  this.tooltip.style['position'] = "absolute";
  this.tooltip.style['opacity'] = '1';
  this.tooltip.style['font-size'] = "12px";
  this.tooltip.style['border'] = 'none';
  this.tooltip.style['border-radius'] = '3px';
  this.tooltip.style['padding'] = '5px';
  this.tooltip.style['text-align'] = 'left';
  this.tooltip.style["background-color"] = this.tooltipColor;
  this.tooltip.style['color'] = 'white';
  this.tooltip.style["visibility"] = "hidden";
  this.tooltip.innerHTML = this.tooltipContent;
}

/**
 * Formats Tooltip Move
 * @param {MouseEvent} e 
 */
export function formatTooltipMove(e) {
  this.tooltip.style["left"] = (e.offsetX + 20) + "px";
  this.tooltip.style["top"] = (e.offsetY + 20) + "px";
}

/**
 * Applies Tooltip
 * @param {MouseEvent} e 
 */
export function applyToolTip(e) {
  this.formatTooltipMove(e);
}

/**
 * Formats Tooltip On
 */
export function formatTooltipOn() {
  if (!(this.tooltip.innerHTML == "" || this.tooltip.innerHTML == "none")) this.tooltip.style["visibility"] = "visible";
}

/** Format Tooltip Off */
export function formatTooltipOff() {
  this.tooltip.style["visibility"] = "hidden";
}
